(function(ArrayUtils) {
    function arraysEqual(a, b) {
        if (a === b) return true;
        if (a == undefined || b == undefined) return false;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i += 1){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    // https://stackoverflow.com/a/16436975/2589276
    ArrayUtils.arraysEqual = arraysEqual;
    function shuffle(array) {
        const tempArray = [
            ...array
        ];
        let counter = tempArray.length;
        // While there are elements in the array
        while(counter > 0){
            // Pick a random index
            const index = Math.floor(Math.random() * counter);
            // Decrease counter by 1
            counter -= 1;
            // And swap the last element with it
            const temp = tempArray[counter];
            tempArray[counter] = tempArray[index];
            tempArray[index] = temp;
        }
        return tempArray;
    }
    ArrayUtils.shuffle = shuffle;
    function arrayMean(array) {
        const minimumNumberOfEntriesNeededToCalculateMean = 1;
        const totalMeasurements = array.length;
        if (array.length < minimumNumberOfEntriesNeededToCalculateMean) return 0;
        return array.reduce((a, b)=>a + b) / totalMeasurements;
    }
    ArrayUtils.arrayMean = arrayMean;
    function arrayStandardDeviation(array, mean, totalMeasurements) {
        const minimumNumberOfEntriesNeededToCalculateStandardDeviation = 2;
        if (array.length < minimumNumberOfEntriesNeededToCalculateStandardDeviation) return 1;
        return Math.sqrt(array.map((x)=>Math.pow(x - mean, 2)).reduce((a, b)=>a + b) / (totalMeasurements - 1));
    }
    ArrayUtils.arrayStandardDeviation = arrayStandardDeviation;
    function arrayStandardError(standardDeviation, totalMeasurements) {
        return standardDeviation / Math.sqrt(totalMeasurements);
    }
    ArrayUtils.arrayStandardError = arrayStandardError;
    function calculateConfidenceInterval95(array) {
        const standardDeviation = arrayStandardDeviation(array, ArrayUtils.arrayMean(array), array.length);
        return standardDeviation * 1.96 / Math.sqrt(array.length);
    }
    ArrayUtils.calculateConfidenceInterval95 = calculateConfidenceInterval95;
    function arrayPercentile(array, percentile) {
        array.sort((a, b)=>a - b);
        const rank = percentile / 100 * (array.length - 1);
        const lowerIndex = Math.floor(rank);
        const upperIndex = Math.ceil(rank);
        if (lowerIndex === upperIndex) {
            return array[lowerIndex];
        } else {
            const weight = rank - lowerIndex;
            return array[lowerIndex] * (1 - weight) + array[upperIndex] * weight;
        }
    }
    ArrayUtils.arrayPercentile = arrayPercentile;
    function randomElementFromArray(array) {
        return array[Math.floor(Math.random() * array.length)];
    }
    ArrayUtils.randomElementFromArray = randomElementFromArray;
    function randomElementsKeepInArray(array, newArrayLength) {
        if (newArrayLength == array.length) return array;
        const newArray = [
            ...array
        ];
        newArray.splice(newArray.indexOf(randomElementFromArray(newArray)), 1);
        return randomElementsKeepInArray(newArray, newArrayLength);
    }
    ArrayUtils.randomElementsKeepInArray = randomElementsKeepInArray;
    function randomElementsThrowFromArray(array, amountToThrow) {
        if (amountToThrow == 0) return array;
        const newArray = [
            ...array
        ];
        newArray.splice(newArray.indexOf(randomElementFromArray(newArray)), 1);
        return randomElementsThrowFromArray(newArray, amountToThrow - 1);
    }
    ArrayUtils.randomElementsThrowFromArray = randomElementsThrowFromArray;
    function removeElementFromArray(array, element) {
        const index = array.indexOf(element);
        if (index > -1) {
            array.splice(index, 1);
            return true;
        }
        return false;
    }
    ArrayUtils.removeElementFromArray = removeElementFromArray;
    function removeOneElement(array, element) {
        const index = array.indexOf(element);
        if (index === -1) return array;
        const newArray = [
            ...array
        ];
        newArray.splice(index, 1);
        return newArray;
    }
    ArrayUtils.removeOneElement = removeOneElement;
    function removeElementsFromArray(array, elements) {
        for (const element of elements){
            removeElementFromArray(array, element);
        }
    }
    ArrayUtils.removeElementsFromArray = removeElementsFromArray;
    function removeDuplicatesFromArray(array) {
        return array.filter((elem, index, self)=>index == self.indexOf(elem));
    }
    ArrayUtils.removeDuplicatesFromArray = removeDuplicatesFromArray;
    function removeAllOccurrenceFromArray(array, valueToRemove) {
        return array.filter((element)=>element !== valueToRemove);
    }
    ArrayUtils.removeAllOccurrenceFromArray = removeAllOccurrenceFromArray;
    function countOccurenceOfValueInArray(array, value) {
        const countOccurrence = array.reduce((a, v)=>v === value ? a + 1 : a, 0);
        return countOccurrence;
    }
    // https://www.codegrepper.com/code-examples/typescript/javascript+Count+the+occurrences+of+a+value+in+an+array
    ArrayUtils.countOccurenceOfValueInArray = countOccurenceOfValueInArray;
    function elementInArray(array, element) {
        for (const arrayObject of array){
            if (arrayObject == element) return true;
        }
        return false;
    }
    ArrayUtils.elementInArray = elementInArray;
    function differenceOfTwoArrays(array1, array2) {
        return array1.filter((character)=>!array2.includes(character));
    }
    ArrayUtils.differenceOfTwoArrays = differenceOfTwoArrays;
    function swapElementOfArray(array, index1, index2) {
        const temp = array[index1];
        array[index1] = array[index2];
        array[index2] = temp;
        return array;
    }
    ArrayUtils.swapElementOfArray = swapElementOfArray;
    function removeAllInstancesOfElementInArray(array, element) {
        return array.filter((value)=>value != element);
    }
    ArrayUtils.removeAllInstancesOfElementInArray = removeAllInstancesOfElementInArray;
    function findIndexGreaterThanOrEqual(sortedArray, thresholdValue) {
        if (sortedArray.length == 0) return -1;
        let startIndex = 0;
        let endIndex = sortedArray.length - 1;
        while(endIndex - startIndex > 1){
            const middleIndex = Math.floor((startIndex + endIndex) / 2);
            if (sortedArray[middleIndex] < thresholdValue) startIndex = middleIndex;
            else endIndex = middleIndex;
        }
        if (sortedArray[startIndex] >= thresholdValue) return startIndex;
        if (sortedArray[endIndex] >= thresholdValue) return endIndex;
        if (sortedArray[endIndex] < thresholdValue) return -1;
        return startIndex;
    }
    ArrayUtils.findIndexGreaterThanOrEqual = findIndexGreaterThanOrEqual;
    function findMaximumIndexLessThanOrEqual(sortedArray, thresholdValue) {
        if (sortedArray.length == 0) return -1;
        let startIndex = 0;
        let endIndex = sortedArray.length - 1;
        while(endIndex - startIndex > 1){
            const middleIndex = Math.floor((startIndex + endIndex) / 2);
            if (sortedArray[middleIndex] <= thresholdValue) startIndex = middleIndex;
            else endIndex = middleIndex;
        }
        if (sortedArray[endIndex] <= thresholdValue) return endIndex;
        if (sortedArray[startIndex] <= thresholdValue) return startIndex;
        if (sortedArray[endIndex] > thresholdValue) return -1;
        return startIndex;
    }
    ArrayUtils.findMaximumIndexLessThanOrEqual = findMaximumIndexLessThanOrEqual;
    function getNElementIfExistsOrClosestLower(array, index) {
        if (array.length == 0) return undefined;
        if (array.length <= index) return array[array.length - 1];
        return array[index];
    }
    ArrayUtils.getNElementIfExistsOrClosestLower = getNElementIfExistsOrClosestLower;
    function sortNumberArrayAscending(array) {
        return array.sort((a, b)=>a - b);
    }
    ArrayUtils.sortNumberArrayAscending = sortNumberArrayAscending;
    function sortNumberArrayDescending(array) {
        return array.sort((a, b)=>b - a);
    }
    ArrayUtils.sortNumberArrayDescending = sortNumberArrayDescending;
    function isSomeElementIncluded(array, elements) {
        return elements.some((element)=>array.includes(element));
    }
    ArrayUtils.isSomeElementIncluded = isSomeElementIncluded;
    function getUniqueElements(array) {
        return Array.from(new Set(array));
    }
    ArrayUtils.getUniqueElements = getUniqueElements;
    function last(array) {
        return array[array.length - 1];
    }
    ArrayUtils.last = last;
})(ArrayUtils || (ArrayUtils = {}));
export var ArrayUtils;
